import { Button } from 'react-bootstrap'

export default function ClearButton(props) {

    const { button_name, onClick } = props

    return (
        <>
            <Button type='button' size='sm' className='ms-1 close_btn' onClick={onClick}>{button_name}</Button>
        </>
    )
}